import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const BlogService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/blogs", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/blogs/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async ({
    search = "",
    status,
    page = 1,
    pageSize = 10,
    fetchAll = true,
  }) => {
    const params = new URLSearchParams({
      ...(search && { search }),
      ...(status && { status }),
      fetchAll: true,
      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    const response = await apiService.get(`/blogs?${params.toString()}`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/blogs/${id}`);
    return response.data;
  },
  getBySlug: async (id) => {
    const response = await apiService.get(`/blogs/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/blogs/${id}`);
    return response.data;
  },
};

export default BlogService;
